import { HttpVerb } from "../../constants";

const panic = async data => {
  console.log(`selfExclude panic api called`);
  let url = "/api/user/panic";
  return await window.ucSDK.api.instance?.authenticatedRequest({
    method: HttpVerb.POST,
    url,
    data: data
  });
};

export default {
  panic: panic
};
